import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { exchangeGoogleSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL fragment
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        
        try {
          const user = await exchangeGoogleSession(sessionId);
          // Clear the hash and navigate to dashboard with user data
          window.history.replaceState(null, '', '/dashboard');
          navigate('/dashboard', { replace: true, state: { user } });
        } catch (error) {
          console.error('Failed to exchange session:', error);
          navigate('/login', { replace: true, state: { error: 'Authentication failed. Please try again.' } });
        }
      } else {
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, []);

  // Show nothing during processing (silent auth)
  return null;
};

export default AuthCallback;
